import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { useNotification } from '@ancert/aui-notification-context';
import AUIInputPasswordField from '@ancert/aui-input-password-field';
import { AUIModal } from '@ancert/aui-modal';

import { useForm } from 'react-hook-form';
import { defaultValues, resolver, validation } from './form';
import { postRenewPassword } from '../../services/user.service';
import { useSession } from '../../context/session.context';

const ModalReestablecerContrasena = ({ show, onClose }) => {
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const { openNotification } = useNotification();
  const { getUser } = useSession();
  const { control, formState, handleSubmit, reset, watch } = useForm({
    defaultValues,
    resolver,
    mode: 'onChange',
  });
  const newPassword = watch('newPassword');
  const confirmNewPassword = watch('confirmNewPassword');

  const validateForm = async () => {
    const isValid = await validation({ newPassword, confirmNewPassword });
    setSubmitDisabled(!isValid);
  };

  useEffect(() => {
    validateForm();
  }, [newPassword, confirmNewPassword]);

  const onSubmit = async (data) => {
    const { login } = getUser();
    const payload = { user: login, newPassword: data.newPassword };
    const { status } = await postRenewPassword({ data: payload });

    if (status === 200) {
      sessionStorage.setItem('renewPassword', btoa('false'));
      setSubmitDisabled(true);
      openNotification({
        title: 'Crear nueva contraseña',
        content: <div>Contraseña cambiada correctamente</div>,
        type: 'success',
        centerButtons: true,
      });
      reset(defaultValues);
      onClose();
    } else {
      openNotification({
        title: 'Crear nueva contraseña',
        content: <div>Se ha producido un error. Por favor vuelva a intentarlo.</div>,
        type: 'error',
        centerButtons: true,
      });
    }
  };

  const tooltipOptions = {
    position: 'bottom',
  };

  const buttons = [
    {
      disabled: submitDisabled,
      id: 'primary',
      mode: 'primary',
      label: 'Aceptar',
      onClick: handleSubmit(onSubmit),
    },
  ];

  return (
    <AUIModal actionButtons={buttons} show={show} title="Crear nueva contraseña" autoHeight size="xs" closeable={false}>
      <form className="c-sii-remember-password" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="o-grid">
          <div className="o-grid__row">
            <div className="o-grid__col-12">
              <AUIInputPasswordField
                iconField="info"
                tooltip="Introduce una nueva contraseña para acceder al canal de denuncias. La contraseña debe tener mínimo 8 caracteres y al menos una mayúscula, una minúscula, un número y un carácter alfanumérico como *, - o #."
                tooltipOptions={tooltipOptions}
                required
                name="newPassword"
                label="Nueva contraseña"
                controlRef={control}
                errors={formState.errors}
              />
            </div>
          </div>
          <div className="o-grid__row">
            <div className="o-grid__col-12">
              <AUIInputPasswordField
                required
                name="confirmNewPassword"
                label="Repetir nueva contraseña"
                controlRef={control}
                errors={formState.errors}
              />
            </div>
          </div>
        </div>
      </form>
    </AUIModal>
  );
};

ModalReestablecerContrasena.propTypes = {
  show: bool,
  onClose: func,
};
ModalReestablecerContrasena.defaultProps = {
  show: false,
  onClose: () => null,
};

export default ModalReestablecerContrasena;
